import { render, staticRenderFns } from "./QuickEntrysHome.vue?vue&type=template&id=c1ff2b5e&scoped=true"
import script from "./QuickEntrysHome.vue?vue&type=script&lang=js"
export * from "./QuickEntrysHome.vue?vue&type=script&lang=js"
import style0 from "./QuickEntrysHome.vue?vue&type=style&index=0&id=c1ff2b5e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ff2b5e",
  null
  
)

export default component.exports